import script from "./profile-update.vue?vue&type=script&setup=true&lang=js"
export * from "./profile-update.vue?vue&type=script&setup=true&lang=js"

import "./profile-update.vue?vue&type=style&index=0&id=6d49a3db&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\rcpetresort.com\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d49a3db"]])

export default __exports__